import React from 'react'
const Button = (props) => {
  if(props.isColour==="chrome"){
    return (
    <a href={props.href}><button className=" text-xl text-center font-semibold  text-[#d2a960] py-2 px-4 border-2 border-[#d2a960] hover:bg-[#d2a960] hover:text-white " onClick={props.changeHandler}>
  {props.label}
</button></a>
  )}
  else if(props.isColour==="black"){
  return (
    <a href={props.href}><button className=" text-center font-semibold  text-black py-2 px-4 border-2 border-black " onClick={props.changeHandler}>
  {props.label}
</button></a>
  )}
    else if(props.isColour){
  return (
    <a href={props.href}> <button className=" text-center font-semibold bg-[#d2a960] text-white py-2 px-4  border-2 border-[#d2a960] hover:bg-transparent hover:text-[#d2a960]" onClick={props.changeHandler}>
  {props.label}
</button></a>
  )}
  else{
      return (
     <a href={props.href}><button className=" text-center bg-transparent text-white font-semibold hover:bg-[#d2a960] py-2 px-4 border-2 border-white hover:border-transparent" onClick={props.changeHandler}>
  {props.label}
</button></a>)
  }
}

export default Button